



















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class InputFieldType extends Vue {
    @Prop({ required: true }) readonly value!: string
    @Prop({ default: 'fields' }) readonly fieldType!: string

    get attrs() {
        return Object.assign({}, this.$attrs, {
            value: this.value,
            options: this.fieldTypeOptions,
        })
    }

    get listeners() {
        return Object.assign({}, this.$listeners, {
            input: this.onInput,
        })
    }

    onInput(value): void {
        if (this.value !== value) {
            this.$emit('input', value)
        }
    }

    get fieldTypes(): string[] {
        if (this.fieldType === 'thankyou_screens') {
            return [
                'thankyou_screen',
                'url_redirect',
            ]
        }

        return [
            'short_text',
            'long_text',
            'number',
            'date',
            // 'group',
            'statement',
            'multiple_choice',
            'picture_choice',
            'yes_no',
            'dropdown',
            'ranking',
            'opinion_scale',
            'rating',
            // 'matrix',
            'phone_number',
            'email',
            'website',
            'payment',
            'file_upload',
            'legal',
        ]
    }

    get fieldTypeOptions() {
        return this.fieldTypes.map(fieldType => ({
            label: this.$t(`company_settings.typeform_forms.field_type.${fieldType}`),
            value: fieldType,
        }))
    }

    fieldIcon(fieldType: string): string {
        return 'icon-typeform-' + fieldType.replace('_', '-')
    }
}
